import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';

import { Compbaser } from '../compbaser';
import { SceneCardTemplateService, ISceneTemplate, ITemplateResolution, ITemplateCategory } from '../../services/scene-card-template.service';
import { CardSceneCreatorService } from '../../services/card-scene-creator.service';
import { ISceneBlock } from '../../interfaces';

export interface DialogSceneCardBrowserData {
    selectedTemplate?: ISceneTemplate;
}

export interface DialogSceneCardBrowserResult {
    template: ISceneTemplate;
    scene: { Player: ISceneBlock };
}

@Component({
    selector: 'app-dialog-scene-card-browser',
    templateUrl: './dialog-scene-card-browser.component.html',
    styleUrls: ['./dialog-scene-card-browser.component.scss']
})
export class DialogSceneCardBrowserComponent extends Compbaser implements OnInit {
    selectedTemplate: ISceneTemplate | null = null;
    filteredTemplates: ISceneTemplate[] = [];
    allTemplates: ISceneTemplate[] = [];
    searchQuery = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DialogSceneCardBrowserData,
        private dialogRef: MatDialogRef<DialogSceneCardBrowserComponent>,
        public override dialog: MatDialog,
        private sceneCardTemplateService: SceneCardTemplateService,
        private cardSceneCreatorService: CardSceneCreatorService,
        private translocoService: TranslocoService
    ) {
        super(dialog);
        if (data?.selectedTemplate) {
            this.selectedTemplate = data.selectedTemplate;
        }
    }

    ngOnInit(): void {
        this.allTemplates = this.sceneCardTemplateService.getTemplates();
        this.filteredTemplates = [...this.allTemplates];
    }

    selectTemplate(template: ISceneTemplate): void {
        this.selectedTemplate = template;
    }

    onSearchChange(): void {
        if (this.searchQuery.trim()) {
            this.filteredTemplates = this.sceneCardTemplateService.searchTemplates(this.searchQuery);
        } else {
            this.filteredTemplates = [...this.allTemplates];
        }
    }

    clearSearch(): void {
        this.searchQuery = '';
        this.onSearchChange();
    }

    applyTemplate(): void {
        if (this.selectedTemplate) {
            this.sceneCardTemplateService.setCurrentTemplate(this.selectedTemplate);

            // Create the actual scene from the template
            const scene = this.cardSceneCreatorService.createSceneFromTemplate(this.selectedTemplate);

            // Return both template and scene
            this.dialogRef.close({
                template: this.selectedTemplate,
                scene: scene
            });
        }
    }

    cancel(): void {
        this.dialogRef.close();
    }

    getRandomTemplate(): void {
        this.selectedTemplate = this.sceneCardTemplateService.getRandomTemplate();
    }

    getCategoryInfo(category: string): ITemplateCategory | undefined {
        return this.sceneCardTemplateService.getCategoryInfo(category);
    }

    getResolutionInfo(resolution: string): ITemplateResolution | undefined {
        return this.sceneCardTemplateService.getResolutionInfo(resolution);
    }
}
